import { render, staticRenderFns } from "./modalDesbloqueioExame.vue?vue&type=template&id=d289290e&"
import script from "./modalDesbloqueioExame.vue?vue&type=script&lang=js&"
export * from "./modalDesbloqueioExame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports